<template lang="html">
  <div class="md:pr-4">
  <div class="bg-white p-8 shadow-lg rounded text-gray-700">
    <span class="mb-4 block border-b pb-4">
      <i class="fab fa-superpowers text-xl"></i>  <span class="text-xl">Heroes Breakdown</span>
    </span>
    <div v-for="hero in heros" v-bind:key="hero.id">
      <a class="pb-2 cursor-pointer hover:text-heroyellow" @click="heroUsers(hero.id), toggle = hero.id">{{hero.title}}</a>
      <span class="float-right">{{percentage( hero.id )}}</span>
      <span class="bg-gray-400 h-4 block mb-4">
        <span :style="'width:'+ percentage( hero.id )" class="bg-heroyellow h-full block"></span>
      </span>
      <div class="bg-gray-100 border px-2 pb-2 mb-4 shadow-md" v-if="toggle == hero.id && usersToggle.length">
      <div v-for="(user,i) in usersToggle" v-bind:key="i">
        <span class="text-xs">
        {{user.email}} | {{user.role}}
        </span>
        <span></span>
      </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
  import heros from "@/data/result/result.json"
  export default {
   data() {
     return {
       heros,
       usersToggle: [],
       toggle: null
     }
   },
   computed: {
     herosCompletedList() {
       let users = this.$attrs.users
       let heros = this.$attrs.heros
       let result = []
       users.forEach(user => {
         heros.forEach(hero => {
           if(hero.uid == user.uid){
             result.push({
               email: user.email,
               hero: hero.number,
               role: user.role
             })
           }
         });
       });
       return result
     },
     herosCompleted() {
       let heros = this.$attrs.heros
       return heros
     },
     herosCompletedCount() {
       var heros = this.$attrs.heros.length
       return heros
     },
   },
   methods: {
     heroUsers( id ) {
       let users = this.herosCompletedList
       this.usersToggle = []
        users.forEach( user => {
          if(user.hero == id){
            this.usersToggle.push({
              email: user.email,
              hero: user.hero,
              role: user.role.name
            })
          }
       })
     },
      percentage( i ) {
        let res = []
        this.herosCompleted.forEach(item => {
          if(item.number == i){
          //console.log(i, item)
          res.push(item.number)
          }
        });
        return (Math.round(res.length * 100 / this.herosCompletedCount) + '%')
      }
   }
  }
</script>
